var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"switch",class:{ checked: _vm.value },on:{"click":function($event){return _vm.$emit('change', !_vm.value)}}})}
var staticRenderFns = []

export { render, staticRenderFns }